import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { toStyled } from '@drone-js/media-query';
import { useThemeContext } from '../../contexts/session/Theme.js';
import styled from 'styled-components';
import { MAXWIDTH } from './Grid.config.js';
import { GridItemStyled } from './GridItem.js';

var _excluded = ["spacing", "fluid", "flexDirection", "qM", "qL", "qXl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GridStyled = /*#__PURE__*/styled.div.withConfig({
  displayName: "Grid__GridStyled",
  componentId: "sc-30ivvs-0"
})(function (props) {
  return _objectSpread(_objectSpread({
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap'
  }, props.$css), props.$q);
});
var propTransform = function propTransform(props, theme) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var spacingProp = props.spacing,
    fluid = props.fluid,
    flexDirection = props.flexDirection,
    _qM = props.qM,
    _qL = props.qL,
    _qXl = props.qXl,
    rest = _objectWithoutProperties(props, _excluded);
  var spacingToken = spacingProp ? theme.spacing[spacingProp] : theme.spacing[0];
  var negSpacingToken = spacingProp && spacingProp !== '0' ? theme.spacing["-".concat(spacingProp)] : theme.spacing[0];
  var spacing = spacingToken !== theme.spacing[0] && _defineProperty({}, "& > ".concat(GridItemStyled), {
    padding: "calc(".concat(spacingToken, " / 2)")
  });
  var width = spacingProp ? "calc(100% + ".concat(spacingToken, ")") : '100%';
  var maxWidth = fluid ? width : "calc(".concat(MAXWIDTH, " + ").concat(spacingToken, ")");
  var margin = spacingProp ? "calc(".concat(negSpacingToken, " / 2)") : undefined;
  return _objectSpread(_objectSpread({}, rest), {}, {
    $css: _objectSpread({
      width: width,
      margin: margin,
      maxWidth: maxWidth,
      flexDirection: flexDirection
    }, spacing)
  });
};
var Grid = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$qL, _props$qL2, _props$qL3, _props$qM, _props$qM2, _props$qM3;
  var theme = useThemeContext();
  var transformProps = propTransform(props, theme);
  var q = toStyled(_objectSpread(_objectSpread({}, props), {}, {
    qL: _objectSpread(_objectSpread({}, props.qL), {}, {
      spacing: ((_props$qL = props.qL) === null || _props$qL === void 0 ? void 0 : _props$qL.spacing) || props.spacing || '16',
      fluid: ((_props$qL2 = props.qL) === null || _props$qL2 === void 0 ? void 0 : _props$qL2.fluid) || props.fluid,
      flexDirection: ((_props$qL3 = props.qL) === null || _props$qL3 === void 0 ? void 0 : _props$qL3.flexDirection) || props.flexDirection
    }),
    qM: _objectSpread(_objectSpread({}, props.qM), {}, {
      spacing: ((_props$qM = props.qM) === null || _props$qM === void 0 ? void 0 : _props$qM.spacing) || props.spacing || '12',
      fluid: ((_props$qM2 = props.qM) === null || _props$qM2 === void 0 ? void 0 : _props$qM2.fluid) || props.fluid,
      flexDirection: ((_props$qM3 = props.qM) === null || _props$qM3 === void 0 ? void 0 : _props$qM3.flexDirection) || props.flexDirection
    })
  }), function (queryProps) {
    return propTransform(queryProps, theme).$css;
  });
  return /*#__PURE__*/React.createElement(GridStyled, _extends({}, transformProps, {
    ref: ref,
    $q: q
  }), props.children);
});
Grid.defaultProps = {
  spacing: '12',
  fluid: false
};
var GridMemoized = /*#__PURE__*/React.memo(Grid);
GridMemoized.displayName = 'Grid';

export { Grid as BaseGrid, GridMemoized as Grid };
//# sourceMappingURL=Grid.js.map
